import React, { lazy, Suspense } from 'react';
import styled from 'styled-components';
import ReactPlayer from 'react-player';
import Text from '../shared/Text';
import Icon from '../shared/Icon';
import { palette } from '../../constants/styles';
import { layout } from 'styled-system';

const StyledWrapper = styled.div`
  position: relative;
  padding-top: 56.25%; /* Player ratio: 100 / (1280 / 720) */
  margin-bottom: 20px;
  ${layout}
`;

const StyledPlayer = styled.div`
  background-color: ${palette.basicGray};
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

const StyledIcon = styled(Icon)`
  z-index: 5;
  position: absolute;
  left: 50%;
  bottom: 45%;
`;

export default function VideoPlayer({ url }) {
  // const LazyPlayer = lazy(() => import('react-player/lib/players/YouTube'));
  return (
    <StyledWrapper>
      <StyledPlayer>
        <ReactPlayer controls light playing={true} height="100%" width="100%" url={url} />
      </StyledPlayer>
    </StyledWrapper>
  );
}
